import { Component, inject, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import Validation from '../../core/utils/validation';
import { Store } from '@ngrx/store';
import { RootState } from '../../core/state/shared/root-state.interface';
import { ActivatedRoute } from '@angular/router';
import { resetPassword } from '../../core/state/password-management/password-management.actions';
import { PasswordPattern } from '../../core/state/password-management/password-management.state';
import { selectResetPasswordErrors } from '../../core/state/password-management/password-management.selectors';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import {
  MatFormField,
  MatSuffix,
  MatHint,
  MatError,
} from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: [
    'reset-password.component.scss',
    '../login-form/login-form.component.scss',
    '../pairing/pairing.component.scss',
    '../forgot-password/forgot-password.component.scss',
  ],
  imports: [
    MatCard,
    MatCardContent,
    MatDivider,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatIcon,
    MatSuffix,
    MatHint,
    MatError,
    MatButton,
    TranslateModule,
  ],
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  token: string;
  username: string;
  showPassword = false;
  showConfirmPassword = false;

  private store = inject(Store<RootState>);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParams['token'];
    this.username = this.route.snapshot.queryParams['username'];

    this.resetForm = new FormGroup(
      {
        password: new FormControl('', [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(PasswordPattern),
        ]),
        confirmPassword: new FormControl('', [Validators.required]),
      },
      {
        validators: [Validation.match('password', 'confirmPassword')],
      },
    );
  }

  get form() {
    return this.resetForm.controls;
  }

  wasTouched(fieldName) {
    const control = this.resetForm.get(fieldName);
    return control.touched || control.dirty;
  }

  onSubmit() {
    this.store.dispatch(
      resetPassword({
        password: this.resetForm.get('password').value,
        token: this.token,
      }),
    );

    this.store.select(selectResetPasswordErrors).subscribe((error) => {
      if (error?.password) {
        if (error.password === 'NON_UNIQUE') {
          this.resetForm.get('password').setErrors({ reusedPassword: true });
          this.resetForm
            .get('confirmPassword')
            .setErrors({ reusedPassword: true });
        } else {
          this.resetForm.get('password').setErrors({ serverError: true });
          this.resetForm
            .get('confirmPassword')
            .setErrors({ serverError: true });
        }
      }
    });
  }
}
